import _map from "lodash/map";
import "core-js/modules/es6.array.find.js";
/* eslint-disable no-param-reassign */
import produce, { original } from 'immer';
import initialState from './initialState';
var sampleLoadingTablesLoaded = produce(function (draft, action) {
  var sampleLoadingTables = action.payload.sampleLoadingTables;
  var originalState = original(draft);
  var newActiveSltId = originalState.meta.activeSltId;
  if (!sampleLoadingTables.find(function (slt) {
    return slt.id === newActiveSltId;
  })) {
    var _sampleLoadingTables$;
    newActiveSltId = ((_sampleLoadingTables$ = sampleLoadingTables[0]) === null || _sampleLoadingTables$ === void 0 ? void 0 : _sampleLoadingTables$.id) || null;
  }
  draft.meta.loading = false;
  draft.meta.initialLoadPending = false;
  draft.meta.activeSltId = newActiveSltId;
  draft.ids = _map(sampleLoadingTables, 'id');
  sampleLoadingTables.forEach(function (slt) {
    draft[slt.id] = slt;
  });
}, initialState);
export default sampleLoadingTablesLoaded;